import { defineComponent, h } from 'vue';
import { QCheckbox } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

export default defineComponent({
    name: 'form-checkbox-dsgn',
    components: {
        QCheckbox,
    },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        cmodel: null,
        readonly: false,
        child: 0,
    },
    render() {
        const value = !!this.cmodel?.[this.schemakey];

        return (
            <div
                class={{ 'designer-form': true }}
                style={{ xmarginLeft: (this.child * 15) + 'px', position: 'relative' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QCheckbox
                    class="caption"
                    dense
                    modelValue={value}
                    disable={this.readonly}
                    label={this.name}
                />
            </div>
        );
    }
});